import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blocker',
  templateUrl: './blocker.component.html',
  styleUrls: ['./blocker.component.css']
})
export class BlockerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  redirectToLp(){
    window.location.href = "http://wap.matrixads.in/mglobopay/qanawatGenericLandingPage?serviceId=1371"
  }

}
